import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import Onboarding from "@/components/molecules/OnBoarding.vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkStatusOnboarding',
  props: {
    novelId: null
  },
  setup(__props: any) {

const props = __props as {
  novelId: string;
};



const workCompletedImagePath = require("@/assets/img/onboarding/work_completed.png");
const closeIconImagePath = require("@/assets/img/onboarding/close_icon.png");

const isVisible = ref(true);

const message = computed(
  () => `
  <div
    style="
      position: relative;
      text-align: center;
      font-size: 14px;
      line-height: 1.1;
      margin-bottom: 16px;
      font-weight: normal;
    "
  >
    <div
      class="close-button"
      style="
        position: absolute;
        right: 0px;
        top: -5px;
        cursor: pointer;
        text-align: center;
      "
    >
      <img
        src="${closeIconImagePath}"
        style="width: 22px; height: auto; display: block; margin: 0 auto"
      />
      <span
        style="display: block; font-size: 8px; color: var(--color-text-secondary); margin-top: 6px; font-weight: bold;"
      >
        閉じる
      </span>
    </div>
    <div style="margin-bottom: 10px">
      <img
        src="${workCompletedImagePath}"
        style="width: 130px; height: auto"
      />
    </div>
    <div style="line-height: 1.3;">
      制作が完了した作品は、<br /><strong>「制作完了」</strong
      >に変更してみましょう。<br /><br />
      左のボタンから、<br />「作品の制作状況」をご変更いただけます。<br /><br />
      NolaのTOP画面から<br />作品の制作状況が一覧で把握できるため、<br />より便利に作品を管理いただくことが可能です。
      <br /><br />
      ぜひご活用ください。
    </div>
  </div>
  <style>
    .edit-button {
      display: inline-block;
      background-color: var(--color-accent);
      color: var(--color-text-inverse);
      font-size: 14px;
      font-weight: bold;
      padding: 10px 20px;
      border: none;
      border-radius: 24px;
      box-shadow: 0 4px 6px var(--color-shadow);
      cursor: pointer;
      margin-bottom: 16px;
    }
    .edit-button:hover {
      filter: brightness(0.9);
    }
  </style>
  <div style="text-align: center">
    <button
      class="edit-button"
    >
      編集画面に移動する
    </button>
  </div>
`
);

// 閉じる処理
function closeOnboarding() {
  isVisible.value = false;
}

// 編集画面に移動
function navigateToEditScreen() {
  router.push({ name: "detailEdit", params: { novelId: props.novelId } });
}

// DOM の準備完了後にイベントリスナーを登録
onMounted(() => {
  const closeButton = document.querySelector(".close-button");
  closeButton?.addEventListener("click", closeOnboarding);

  const editButton = document.querySelector(".edit-button");
  editButton?.addEventListener("click", navigateToEditScreen);
});

return { __sfc: true,props, workCompletedImagePath, closeIconImagePath, isVisible, message, closeOnboarding, navigateToEditScreen, Onboarding }
}

})